
import React from 'react';
import { Helmet } from 'react-helmet-async';
import SubHeader from '../components/SubHeader';
import GetInTouch from '../components/GetInTouch';

const Contact = () => {
  const contactSchema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Nagpur Best Interior Designer | ERA Interio",
    "description":
      "Looking for the Nagpur best interior designer? Call us, share your ideas and book a consultation for your dream home today.",
    "image":
      "https://www.erainterio.com/static/media/eraintrerio-01.619cace3e540999f3bf5.png",
    "@id": "https://www.erainterio.com/contact-us#professionalservice",
    "url": "https://www.erainterio.com/contact-us",
    "telephone": "+91-8830219839",
    "address": {
      "@type": "PostalAddress",
      "streetAddress":
        "Shop No.2, 1st Floor, Shyama Apartment, Pratap Nagar Square, Pratap Nagar",
      "addressLocality": "Nagpur",
      "addressRegion": "Maharashtra",
      "postalCode": "440022",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 21.1130412,
      "longitude": 79.0561782
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "10:00",
        "closes": "19:00"
      }
    ],
    "sameAs": [
      "http://www.facebook.com/erainterior9",
      "https://www.instagram.com/erainterio9/",
      "https://www.youtube.com/@eraintero"
    ]
  };

  return (
    <>
      <Helmet>
        {/* SEO Title */}
        <title>
          Nagpur Best Interior Designer, Let’s Design Your Home | ERA Interio
        </title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Looking for the Nagpur best interior designer? Call us, share your ideas and book a consultation for your dream home today."
        />

        {/* Keywords */}
        <meta
          name="keywords"
          content="Nagpur Best Interior Designer, Interior Design, Design Inside Nagpur, Home Design, Nagpur Interior Designer, Top 10 Interior Designers in Nagpur"
        />

        {/* Robots */}
        <meta
          name="robots"
          content="index, follow, max-image-preview:large"
        />

        {/* Canonical */}
        <link
          rel="canonical"
          href="https://www.erainterio.com/contact-us"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="We Are Ready to Connect with You for Beautiful Interior Design & House Design"
        />

        <meta
          property="og:description"
          content="Your dream home deserves a beautiful design. Let’s connect and turn your interior design ideas into reality with ERA Interio."
        />

        <meta
          property="og:image"
          content="https://www.erainterio.com/images/contact-us-image.jpg"
        />

        <meta
          property="og:url"
          content="https://www.erainterio.com/contact-us"
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:site_name"
          content="ERA Interio"
        />

        {/* Twitter */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="We Are Ready to Connect with You for Beautiful Interior Design & House Design"
        />

        <meta
          name="twitter:description"
          content="Your dream home deserves a beautiful design. Let’s connect and turn your interior design ideas into reality with ERA Interio."
        />

        <meta
          name="twitter:image"
          content="https://www.erainterio.com/images/contact-us-image.jpg"
        />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(contactSchema)}
        </script>
      </Helmet>

      <SubHeader
        seoTitle="Contact the Nagpur Best Interior Designer for Your Home"
      />

      <GetInTouch />
    </>
  );
};

export default Contact;
